function checkContainer() {
  if(jQuery('.rebuy-reorder-cross-sell-item').is(':visible')) {
    jQuery('.rebuy-reorder-cross-sell-items').slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      prevArrow: jQuery('.rebuy-reorder-cross-sell-item--wrapper--navigation').find('.slick-prev'),
      nextArrow: jQuery('.rebuy-reorder-cross-sell-item--wrapper--navigation').find('.slick-next'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          } 
        }
      ]
    });
  } else {
    setTimeout(checkContainer, 50); //wait 50 ms, then try again
  } 
}

window.onload = function() {
  checkContainer();  
}